import { getTaskNumber, InvoiceStatus } from '@admiin-com/ds-graphql';
import { gql, useQuery } from '@apollo/client';
import { useCurrentEntityId } from '../useSelectedEntity/useSelectedEntity';

export const useNewTaskNumber = (
  invoiceStatus: InvoiceStatus = InvoiceStatus.INVOICE
) => {
  const entityId = useCurrentEntityId();

  const { data } = useQuery(gql(getTaskNumber), {
    variables: {
      entityId: entityId,
    },
    nextFetchPolicy: 'network-only',
    fetchPolicy: 'network-only',
    skip: !entityId,
  });

  const taskNumber = data?.getTaskNumber
    ? invoiceStatus === InvoiceStatus.INVOICE
      ? data?.getTaskNumber?.invoice
      : data?.getTaskNumber?.quote ?? 1
    : 1;

  const invoiceNumberPlaceholder = `${
    invoiceStatus === InvoiceStatus.INVOICE ? 'INV' : 'QTE'
  }-${String(taskNumber + 1).padStart(3, '0')}`;

  return { taskNumber, placeholder: invoiceNumberPlaceholder };
};
